import { GENERIC_ERROR_MESSAGE, STATUS_FAILURE, STATUS_PENDING, STATUS_SUCCESS } from 'Common/constants/commonConstants';
import * as AuthorizationConstants from './AuthorizationConstants';

const assign = Object.assign || require('object.assign');

// The initial application state
const initialState = {
    showAuthErrorModal: false,
    isFileTransferAuthorized: true,
    isRDSAuthorized:true,
    allowedFeaturesList:[],
    authorizeRequestStatus: STATUS_SUCCESS,
    authorizedAssignedRoles: [],
    authorizeRequestError: ""
};

export default function AuthorizationReducer(state = initialState, action) {
    switch (action.type) {
        case AuthorizationConstants.AUTH_ERROR_MODAL:
                return assign({}, state, {
                showAuthErrorModal: action.displayModal
            });
            break;
        case AuthorizationConstants.AUTH_ALLOWED_DEVICE_FEATURES_SUCCESS:{
            let deviceFeaturesList = action.newState.result;            
            return assign({},state,{
                showAuthErrorModal: false,
                isFileTransferAuthorized: deviceFeaturesList.filter(e => e === 'filetransfer').length > 0 ? true : false,
                isRDSAuthorized:deviceFeaturesList.filter(e => e === 'rds').length > 0 ? true : false,
                allowedFeaturesList:deviceFeaturesList    
            });
        }
        case AuthorizationConstants.AUTH_ALLOWED_DEVICE_FEATURES_FAILURE:{
              return assign({},state,{
                showAuthErrorModal: false,
                isFileTransferAuthorized: true,
                isRDSAuthorized:true,
                allowedFeaturesList:[]    
            });
        }
        case AuthorizationConstants.UM_AUTHORIZE_REQUEST: {
            return assign({}, state, {
                authorizeRequestStatus: STATUS_PENDING,
                authorizedAssignedRoles: [],
                authorizeRequestError: ""
            });
        }
        case AuthorizationConstants.UM_AUTHORIZE_SUCCESS: {
            return assign({}, state, {
                authorizeRequestStatus: STATUS_SUCCESS,
                authorizedAssignedRoles: [...action?.payload?.result?.roles]
            });
        }
        case AuthorizationConstants.UM_AUTHORIZE_FAILURE: {
            return assign({}, state, {
                authorizeRequestStatus: STATUS_FAILURE,
                authorizeRequestError: action?.payload?.message || GENERIC_ERROR_MESSAGE
            });
        }
        case AuthorizationConstants.UM_RESET_AUTHORIZE_FAILURE_STATUS: {
            return assign({}, state, {
                authorizeRequestStatus: STATUS_SUCCESS,
                authorizeRequestError: ""
            });
        }
        default:
            return state;
    }
}